<button [ngClass]="{'is-selected': isSelected}" class="route">
    <div class="route__column row">
        <span class="route__column__hour">
            {{ _data.St | date : 'H:mm' }}
        </span>
        <div class="column">
            <span class="route__column__street">
                <ng-container *ngIf="!_data.D.S?.Cr && !_data.D.S?.Br && !_data.D.S?.St">
                    {{ 'reports.noGPS' | translate }}
                </ng-container>

                <ng-container *ngIf="_data.D.S?.Cr">
                    {{_data.D.S?.Cr}}, 
                </ng-container>
                <ng-container *ngIf="_data.D.S?.Br">
                    {{_data.D.S?.Br}}
                </ng-container>
            </span>
            <span class="route__column__street">
                <ng-container *ngIf="_data.D.S?.St">
                    ul. {{_data.D.S?.St}}
                </ng-container>
            </span>
        </div>
    </div>
    <div class="route__column row">
        <span class="route__column__hour">
            {{ _data.En | date : 'H:mm ' }}
        </span>
        <div class="column">
            <span class="route__column__street">
                <ng-container *ngIf="!_data.D.E?.Cr && !_data.D.E?.Br && !_data.D.E?.St">
                    {{ 'reports.noGPS' | translate }}
                </ng-container>

                <ng-container *ngIf="_data.D.E?.Cr">
                    {{_data.D.E?.Cr}}, 
                </ng-container>
                <ng-container *ngIf="_data.D.E?.Br">
                    {{_data.D.E?.Br}}
                </ng-container>
            </span>
            <span class="route__column__street">
                <ng-container *ngIf="_data.D.E?.St">
                    ul. {{_data.D.E?.St}}
                </ng-container>
            </span>
        </div>
    </div>
    <div class="route__column summary column">
        <div class="route__column__route-summary row">
            <span>{{ _data.D.D | distance }}</span>
            <span>{{ _data | calculateDiffrenceBetweenDatesAndReturnTime }}</span>
            <span>{{ _data.stopTimeInMinutes === 1 ? "&lt;1min" : stopTime }}</span>
        </div>

        <div 
            [ngClass]="{ 'is-visible': driverData }"
            class="route__column__driver"
        >
            <div class="route__column__driver__avatar">
                <span>
                    {{ $any(driverData?.FN?.slice(0,1)) + $any(driverData?.LN?.slice(0,1)) }}
                </span>
            </div>
            <span class="route__column__driver__title">
                {{ driverData?.FN + ' ' + driverData?.LN }}
            </span>
        </div>
    </div>
</button>
